export default __webpack_public_path__ + "static/media/nizniy_novgorod.6580305b.pdf";